import { Button, Container, Typography } from "@mui/material";
import { useCallback } from "react";

export const ForbiddenPage = () => {
  const goHomeTopReplace = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    try {
      window.top?.location.replace("/");
    } catch {
      window.location.replace("/");
    }
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 10, textAlign: "center" }}>
      <Typography variant="h1" component="h1" gutterBottom color="error">
        403
      </Typography>
      <Typography variant="h5" gutterBottom>
        Доступ запрещён
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        У вас нет прав для просмотра этой страницы.
      </Typography>
      <Button
        component="a"
        href="/"
        onClick={goHomeTopReplace}
        variant="contained"
        color="primary"
      >
        Вернуться на главную
      </Button>
    </Container>
  );
};
